const productData = [
  {
    id: 1,
    name: "Aurora Retractable Gel Pens",
    brand: "Kado Works",
    category: "Pens",
    subcategory: "Gel Pens",
    price: 49,
    image: "/img/product-01.jpg",
    images: ["/img/product-01.jpg", "/img/product-01-detail.jpg"],
    description:
      "A coordinated trio of smooth, quick-drying gel pens in calm everyday colors. Each pen combines a balanced soft-touch barrel with a precise needle tip, producing a clean, consistent line for meeting notes, study sessions, journaling, and daily planning without tiring the hand.",
    attributes: { tip: "0.5 mm", ink: "Water-based gel", origin: "Curated in Hong Kong" },
    size: ["0.5 mm"],
    colors: ["Meadow trio", "Twilight trio"],
    tags: ["writing", "quick-dry", "editor-pick"],
    features: ["Quick-drying archival ink", "Soft-touch matte barrel", "Refillable design"],
    rating: 4.8,
    reviews: 86,
    stock: 34,
    featured: true,
    newArrival: false,
  },
  {
    id: 2,
    name: "Fieldnote Brass Rollerball",
    brand: "Northline Tools",
    category: "Pens",
    subcategory: "Ballpoint Pens",
    price: 69,
    image: "/img/product-02.jpg",
    images: ["/img/product-02.jpg", "/img/product-02-detail.jpg"],
    description:
      "A reassuringly weighty rollerball pairing a warm brushed-brass cap with a comfortable charcoal grip. Its balanced construction supports a steady, fluid line, while the replaceable standard refill makes it a dependable choice for signatures, correspondence, and years of everyday writing.",
    attributes: { tip: "0.7 mm", ink: "Black rollerball", body: "Brass and aluminum" },
    size: ["0.7 mm"],
    colors: ["Brass & charcoal"],
    tags: ["writing", "metal", "gift"],
    features: ["Replaceable standard refill", "Threaded cap", "Naturally developing brass patina"],
    rating: 4.7,
    reviews: 51,
    stock: 18,
    featured: true,
    newArrival: false,
  },
  {
    id: 3,
    name: "Lumen Fine Fountain Pen",
    brand: "Nami Studio",
    category: "Pens",
    subcategory: "Fountain Pens",
    price: 88,
    image: "/img/product-03.jpg",
    images: ["/img/product-03.jpg", "/img/product-03-detail.jpg"],
    description:
      "A compact fountain pen with a polished fine nib, deep olive lacquer, and restrained warm-metal details. The smooth snap cap, included converter, and comfortable proportions make it an approachable first fountain pen as well as a reliable daily writer for notes and letters.",
    attributes: { nib: "Fine", filling: "Converter or cartridge", body: "Lacquered brass" },
    size: ["Fine", "Medium"],
    colors: ["Deep olive", "Ink blue"],
    tags: ["fountain-pen", "refillable", "gift"],
    features: ["Polished steel nib", "Snap-fit cap", "Converter included"],
    rating: 4.9,
    reviews: 112,
    stock: 22,
    featured: true,
    newArrival: true,
  },
  {
    id: 4,
    name: "Willow Dual Brush Marker Set",
    brand: "Tono Color Lab",
    category: "Pens",
    subcategory: "Brush Pens",
    price: 55,
    image: "/img/product-04.jpg",
    images: ["/img/product-04.jpg", "/img/product-04-detail.jpg"],
    description:
      "Six botanical-toned markers designed for expressive lettering and controlled illustration. A flexible brush tip creates sweeping strokes and varied line weight, while the fine detail tip handles outlines, labels, and compact notes; the water-based colors layer and blend with minimal odor.",
    attributes: { count: "6 markers", tips: "Brush and 0.8 mm", ink: "Water-based dye" },
    size: ["Set of 6"],
    colors: ["Botanical", "Dusk"],
    tags: ["lettering", "illustration", "color"],
    features: ["Blendable dye ink", "Color-coded caps", "Low-odor formula"],
    rating: 4.6,
    reviews: 47,
    stock: 29,
    featured: true,
    newArrival: false,
  },
  {
    id: 5,
    name: "Haze Twin Highlighter Set",
    brand: "Tono Color Lab",
    category: "Pens",
    subcategory: "Highlighters",
    price: 45,
    image: "/img/product-05.jpg",
    images: ["/img/product-05.jpg", "/img/product-05-detail.jpg"],
    description:
      "Five calm translucent colors that bring structure to a page without obscuring the words beneath. Dual chisel widths move easily between broad passages and fine underlining, and the fast-drying water-based ink is suited to textbooks, planners, meeting notes, and revision cards.",
    attributes: { count: "5 markers", tips: "4 mm and 1 mm", ink: "Translucent water-based" },
    size: ["Set of 5"],
    colors: ["Morning haze"],
    tags: ["study", "planning", "pastel"],
    features: ["Two chisel widths", "Fast-drying ink", "Works over gel and ballpoint ink"],
    rating: 4.8,
    reviews: 94,
    stock: 41,
    featured: true,
    newArrival: false,
  },
  {
    id: 6,
    name: "Sumi Technical Fineliner Set",
    brand: "Outline Office",
    category: "Pens",
    subcategory: "Brush Pens",
    price: 52,
    image: "/img/product-06.jpg",
    images: ["/img/product-06.jpg", "/img/product-06-detail.jpg"],
    description:
      "A six-width drawing set for technical diagrams, crisp outlines, cross-hatching, and tiny details. Each pen contains fade-resistant black pigment ink that becomes waterproof when dry, making the set useful for sketching, annotation, design work, and mixed-media layering.",
    attributes: { widths: "0.05–0.8 mm", ink: "Black pigment", count: "6 pens" },
    size: ["Set of 6"],
    colors: ["Carbon black"],
    tags: ["drawing", "waterproof", "technical"],
    features: ["Waterproof when dry", "Fade-resistant pigment", "Ventilated caps"],
    rating: 4.7,
    reviews: 38,
    stock: 26,
    featured: false,
    newArrival: true,
  },
  {
    id: 7,
    name: "Orbit Drafting Pencil",
    brand: "Northline Tools",
    category: "Pencils",
    subcategory: "Mechanical Pencils",
    price: 58,
    image: "/img/product-07.jpg",
    images: ["/img/product-07.jpg", "/img/product-07-detail.jpg"],
    description:
      "A slim mechanical pencil engineered around a stable knurled grip and low center of gravity. The retractable lead sleeve protects pockets between uses, while the metal clip, built-in eraser, and balanced body support precise drafting, calculations, and long writing sessions.",
    attributes: { lead: "0.5 mm", body: "Aluminum and steel", weight: "19 g" },
    size: ["0.5 mm", "0.7 mm"],
    colors: ["Midnight blue", "Graphite"],
    tags: ["drafting", "refillable", "mechanical"],
    features: ["Retractable lead sleeve", "Built-in eraser", "Metal pocket clip"],
    rating: 4.8,
    reviews: 73,
    stock: 31,
    featured: true,
    newArrival: false,
  },
  {
    id: 8,
    name: "Cedar Color Pencil Twelve",
    brand: "Pine & Pigment",
    category: "Pencils",
    subcategory: "Wood Pencils",
    price: 48,
    image: "/img/product-08.jpg",
    images: ["/img/product-08.jpg", "/img/product-08-detail.jpg"],
    description:
      "Twelve richly pigmented colored pencils in a grounded palette chosen for landscapes, studies, and everyday color work. Smooth wax-based cores layer evenly and resist breakage, while the natural cedar barrels sharpen cleanly and feel comfortable during longer drawing sessions.",
    attributes: { count: "12 pencils", core: "3.3 mm wax-based", wood: "FSC-certified cedar" },
    size: ["Set of 12"],
    colors: ["Field palette"],
    tags: ["drawing", "colored-pencil", "kids"],
    features: ["Break-resistant core", "Smooth layering", "Unlacquered cedar barrel"],
    rating: 4.6,
    reviews: 29,
    stock: 24,
    featured: false,
    newArrival: true,
  },
  {
    id: 9,
    name: "Slate Lead & Eraser Kit",
    brand: "Outline Office",
    category: "Pencils",
    subcategory: "Lead & Erasers",
    price: 45,
    image: "/img/product-09.jpg",
    images: ["/img/product-09.jpg", "/img/product-09-detail.jpg"],
    description:
      "A tidy maintenance set combining strong 0.5 mm polymer leads in HB, B, and 2B with three soft, low-dust pebble erasers. The different grades cover everyday writing through darker sketch work, and the reusable tubes keep refills protected and easy to identify.",
    attributes: { lead: "0.5 mm HB, B, 2B", erasers: "PVC-free", count: "3 tubes + 3 erasers" },
    size: ["0.5 mm"],
    colors: ["Slate gray"],
    tags: ["refill", "eraser", "drawing"],
    features: ["Low-dust erasers", "Strong polymer lead", "Reusable lead tubes"],
    rating: 4.5,
    reviews: 18,
    stock: 45,
    featured: false,
    newArrival: false,
  },
  {
    id: 10,
    name: "Terra 2 mm Clutch Pencil",
    brand: "Northline Tools",
    category: "Pencils",
    subcategory: "Mechanical Pencils",
    price: 72,
    image: "/img/product-10.jpg",
    images: ["/img/product-10.jpg", "/img/product-10-detail.jpg"],
    description:
      "A substantial 2 mm clutch pencil for broad sketching, shading, and decisive drafting. Its anodized aluminum body is balanced by a knurled brass grip, while the drop-clutch mechanism and integrated pointer make it easy to adjust and sharpen the included graphite lead anywhere.",
    attributes: { lead: "2 mm HB included", body: "Anodized aluminum", grip: "Knurled brass" },
    size: ["2 mm"],
    colors: ["Terracotta", "Forest"],
    tags: ["drafting", "sketching", "metal"],
    features: ["Drop-clutch mechanism", "Integrated lead pointer", "Replaceable 2 mm lead"],
    rating: 4.7,
    reviews: 41,
    stock: 16,
    featured: true,
    newArrival: false,
  },
  {
    id: 11,
    name: "Linen Grid Notebook A5",
    brand: "June Paper Co.",
    category: "Paper",
    subcategory: "Notebooks",
    price: 64,
    image: "/img/product-11.jpg",
    images: ["/img/product-11.jpg", "/img/product-11-detail.jpg"],
    description:
      "A refined clothbound notebook filled with 192 fountain-pen-friendly ivory pages. The subtle 5 mm grid supports notes, lists, diagrams, and gentle planning without dominating the page; thread-sewn binding lets the book lie flat, with a ribbon marker and elastic closure for daily use.",
    attributes: { size: "A5 / 148 × 210 mm", pages: "192", paper: "90 gsm ivory grid" },
    size: ["A5", "A6"],
    colors: ["Moss", "Clay", "Ink"],
    tags: ["notebook", "grid", "fountain-pen-friendly"],
    features: ["Thread-sewn binding", "Lays flat", "Ribbon marker and elastic closure"],
    rating: 4.9,
    reviews: 137,
    stock: 38,
    featured: true,
    newArrival: false,
  },
  {
    id: 12,
    name: "Pocket Memo Book Trio",
    brand: "June Paper Co.",
    category: "Paper",
    subcategory: "Notebooks",
    price: 45,
    image: "/img/product-12.jpg",
    images: ["/img/product-12.jpg", "/img/product-12-detail.jpg"],
    description:
      "A set of three flexible pocket notebooks sized for bags, jackets, and quick notes on the move. Plain, ruled, and dot-grid interiors provide a useful choice for sketches, lists, and plans, while stitch binding and sturdy recycled covers stand up to everyday carrying.",
    attributes: { size: "90 × 140 mm", pages: "48 each", rulings: "Plain, ruled, dot grid" },
    size: ["Pocket trio"],
    colors: ["Coastal", "Earth"],
    tags: ["memo", "pocket", "set"],
    features: ["Recycled cover stock", "Stitch binding", "Three interior rulings"],
    rating: 4.6,
    reviews: 54,
    stock: 42,
    featured: false,
    newArrival: false,
  },
  {
    id: 13,
    name: "Sunday Letter Writing Set",
    brand: "June Paper Co.",
    category: "Paper",
    subcategory: "Letter Sets",
    price: 48,
    image: "/img/product-13.jpg",
    images: ["/img/product-13.jpg", "/img/product-13-detail.jpg"],
    description:
      "A considered correspondence set of tactile cream laid paper and softly colored envelopes, made for thank-you notes, invitations, and letters worth keeping. The smooth 100 gsm sheets handle fountain pens comfortably, and gummed flaps plus a paper belly band keep the set neat between uses.",
    attributes: { sheets: "12", envelopes: "6", paper: "100 gsm laid finish" },
    size: ["A5 letter size"],
    colors: ["Dusty blue", "Sage"],
    tags: ["letter-writing", "gift", "paper"],
    features: ["Fountain-pen friendly", "Gummed envelope flaps", "Paper belly band"],
    rating: 4.8,
    reviews: 63,
    stock: 20,
    featured: true,
    newArrival: false,
  },
  {
    id: 14,
    name: "Perpetual Weekly Planner",
    brand: "Monday Press",
    category: "Paper",
    subcategory: "Planners",
    price: 76,
    image: "/img/product-14.jpg",
    images: ["/img/product-14.jpg", "/img/product-14-detail.jpg"],
    description:
      "An undated 52-week planner that begins whenever you are ready. Uncluttered weekly spreads leave room for appointments, priorities, and open notes, while monthly overview pages and a durable cloth hardcover support an entire year of flexible personal or project planning.",
    attributes: { size: "B6 / 128 × 182 mm", pages: "128", layout: "Undated weekly" },
    size: ["B6"],
    colors: ["Ochre", "Cloud gray"],
    tags: ["planner", "undated", "organization"],
    features: ["52 weekly spreads", "Monthly overview pages", "Cloth hardcover"],
    rating: 4.7,
    reviews: 76,
    stock: 27,
    featured: false,
    newArrival: true,
  },
  {
    id: 15,
    name: "Cotton Paper Sketchbook",
    brand: "Pine & Pigment",
    category: "Paper",
    subcategory: "Sketchbooks",
    price: 68,
    image: "/img/product-15.jpg",
    images: ["/img/product-15.jpg", "/img/product-15-detail.jpg"],
    description:
      "A lay-flat sketchbook filled with toothy, acid-free cotton-blend paper for graphite, ink, colored pencil, and controlled light washes. Exposed thread binding opens completely flat across every spread, giving studies and larger compositions a comfortable uninterrupted working surface.",
    attributes: { size: "B5 / 176 × 250 mm", pages: "80", paper: "180 gsm cotton blend" },
    size: ["B5", "A5"],
    colors: ["Charcoal spine"],
    tags: ["sketchbook", "art", "mixed-media"],
    features: ["Acid-free paper", "Exposed thread binding", "Opens completely flat"],
    rating: 4.8,
    reviews: 48,
    stock: 23,
    featured: true,
    newArrival: false,
  },
  {
    id: 16,
    name: "Earth Tone Washi Tape Set",
    brand: "Small Hours",
    category: "More",
    subcategory: "Tape & Stickers",
    price: 45,
    image: "/img/product-16.jpg",
    images: ["/img/product-16.jpg", "/img/product-16-detail.jpg"],
    description:
      "Five rolls of matte paper tape in a grounded, versatile palette for journals, parcels, labels, and gentle color coding. The repositionable adhesive lifts cleanly during layout, each roll tears neatly by hand, and the writable surface accepts pens and pencils for quick annotations.",
    attributes: { count: "5 rolls", width: "15 mm", length: "7 m each" },
    size: ["15 mm × 7 m"],
    colors: ["Earth", "Coast"],
    tags: ["washi", "journaling", "craft"],
    features: ["Repositionable adhesive", "Tears cleanly by hand", "Writable matte surface"],
    rating: 4.7,
    reviews: 69,
    stock: 50,
    featured: false,
    newArrival: false,
  },
  {
    id: 17,
    name: "Corner Index Sticker Library",
    brand: "Small Hours",
    category: "More",
    subcategory: "Tape & Stickers",
    price: 45,
    image: "/img/product-17.jpg",
    images: ["/img/product-17.jpg", "/img/product-17-detail.jpg"],
    description:
      "A practical library of 180 geometric tabs and dots for marking references, separating projects, and building an intuitive visual index. Six matte sheets include four writable colors and several useful shapes, with low-tack adhesive that can be repositioned without overwhelming delicate paper.",
    attributes: { count: "180 stickers", sheets: "6", finish: "Matte paper" },
    size: ["6-sheet set"],
    colors: ["Archive palette"],
    tags: ["stickers", "indexing", "planning"],
    features: ["Four writable colors", "Low-tack adhesive", "Six practical shapes"],
    rating: 4.5,
    reviews: 32,
    stock: 37,
    featured: false,
    newArrival: true,
  },
  {
    id: 18,
    name: "Canvas Zip Pen Case",
    brand: "Thread & Tool",
    category: "More",
    subcategory: "Cases & Bags",
    price: 59,
    image: "/img/product-18.jpg",
    images: ["/img/product-18.jpg", "/img/product-18-detail.jpg"],
    description:
      "A compact, hard-wearing cotton canvas case that organizes up to fifteen pens without taking over a work bag. Reinforced seams, a smooth metal zipper, washable lining, and a structured base protect everyday writing tools while keeping them easy to reach at a desk or on the move.",
    attributes: { dimensions: "195 × 55 × 50 mm", material: "12 oz cotton canvas", capacity: "Up to 15 pens" },
    size: ["Standard"],
    colors: ["Burnt orange", "Moss", "Natural"],
    tags: ["pen-case", "canvas", "travel"],
    features: ["YKK-style metal zipper", "Washable cotton lining", "Reinforced pull tab"],
    rating: 4.8,
    reviews: 81,
    stock: 25,
    featured: true,
    newArrival: false,
  },
  {
    id: 19,
    name: "Foldout Stationery Tool Pouch",
    brand: "Thread & Tool",
    category: "More",
    subcategory: "Cases & Bags",
    price: 89,
    image: "/img/product-19.jpg",
    images: ["/img/product-19.jpg", "/img/product-19-detail.jpg"],
    description:
      "A foldout canvas organizer that keeps a complete small creative kit visible and orderly. Eight elastic pen loops, seven practical pockets, a secure zipped section, and a wrap closure provide dedicated space for writing tools, cables, small rulers, clips, and travel essentials.",
    attributes: { openSize: "390 × 210 mm", material: "Cotton canvas", pockets: "7 + 8 loops" },
    size: ["Standard"],
    colors: ["Soft sage", "Charcoal"],
    tags: ["organizer", "travel", "canvas"],
    features: ["Eight elastic pen loops", "Zipped accessories pocket", "Secure wrap closure"],
    rating: 4.9,
    reviews: 44,
    stock: 0,
    featured: true,
    newArrival: false,
  },
  {
    id: 20,
    name: "Pebble Ceramic Safety Cutter",
    brand: "Kado Works",
    category: "More",
    subcategory: "Desk Tools",
    price: 47,
    image: "/img/product-20.jpg",
    images: ["/img/product-20.jpg", "/img/product-20-detail.jpg"],
    description:
      "A palm-size ceramic safety cutter for opening parcels, trimming paper, and handling everyday desk tasks. The rounded mineral-composite body sits comfortably in either hand, while the auto-retracting replaceable blade limits exposure and a small lanyard opening keeps it easy to store.",
    attributes: { length: "78 mm", blade: "Replaceable ceramic", body: "Mineral composite" },
    size: ["One size"],
    colors: ["Oat", "Slate"],
    tags: ["cutter", "desk-tool", "ceramic"],
    features: ["Auto-retracting blade", "Ambidextrous slider", "Lanyard opening"],
    rating: 4.6,
    reviews: 39,
    stock: 33,
    featured: false,
    newArrival: true,
  },
  {
    id: 21,
    name: "Arch Desktop Tape Dispenser",
    brand: "Kado Works",
    category: "More",
    subcategory: "Desk Tools",
    price: 92,
    image: "/img/product-21.jpg",
    images: ["/img/product-21.jpg", "/img/product-21-detail.jpg"],
    description:
      "A stable cast-metal tape dispenser with a clean architectural profile and warm brass-toned spindle. Its substantial weight and non-slip cork base support true one-handed operation, while the replaceable steel edge cuts cleanly and accepts common tape rolls up to 25 mm wide.",
    attributes: { capacity: "Tape up to 25 mm", weight: "620 g", body: "Powder-coated metal" },
    size: ["Desktop"],
    colors: ["Charcoal & brass", "Warm white"],
    tags: ["tape", "desk-tool", "metal"],
    features: ["Non-slip cork base", "Replaceable steel cutter", "One-handed operation"],
    rating: 4.8,
    reviews: 27,
    stock: 14,
    featured: true,
    newArrival: false,
  },
  {
    id: 22,
    name: "Mini Forged Brass Scissors",
    brand: "Northline Tools",
    category: "More",
    subcategory: "Desk Tools",
    price: 66,
    image: "/img/product-22.jpg",
    images: ["/img/product-22.jpg", "/img/product-22-detail.jpg"],
    description:
      "Compact sharp-point scissors with comfortable rounded handles for paper, thread, ribbon, and precise desk-side work. Fine carbon-steel blades meet cleanly along the cutting edge, and the included cotton sleeve protects both the points and nearby tools when stored or carried.",
    attributes: { length: "115 mm", blade: "55 mm", material: "Brass-plated carbon steel" },
    size: ["Mini"],
    colors: ["Warm brass"],
    tags: ["scissors", "craft", "desk-tool"],
    features: ["Fine pointed blades", "Hand-finished edges", "Protective cotton sleeve"],
    rating: 4.7,
    reviews: 36,
    stock: 19,
    featured: false,
    newArrival: false,
  },
  {
    id: 23,
    name: "Field Gouache Travel Palette",
    brand: "Pine & Pigment",
    category: "More",
    subcategory: "Art Supplies",
    price: 118,
    image: "/img/product-23.jpg",
    images: ["/img/product-23.jpg", "/img/product-23-detail.jpg"],
    description:
      "Twelve opaque, richly pigmented gouache colors arranged in a compact enameled metal tin for studio or travel use. Removable half pans rewet smoothly, the balanced landscape palette mixes cleanly, and three generous lid wells provide space for tints, neutrals, and larger washes.",
    attributes: { colors: "12 half pans", binder: "Gum arabic", case: "Enameled steel" },
    size: ["12-color set"],
    colors: ["Landscape palette"],
    tags: ["gouache", "painting", "travel"],
    features: ["Rewettable artist colors", "Removable pans", "Three mixing wells"],
    rating: 4.9,
    reviews: 58,
    stock: 17,
    featured: true,
    newArrival: true,
  },
  {
    id: 24,
    name: "Natural Canvas Brush Roll",
    brand: "Thread & Tool",
    category: "More",
    subcategory: "Art Supplies",
    price: 78,
    image: "/img/product-24.jpg",
    images: ["/img/product-24.jpg", "/img/product-24-detail.jpg"],
    description:
      "A washable natural-canvas roll paired with six versatile synthetic brushes for watercolor, gouache, ink, and travel sketching. The selection covers fine lines, controlled shapes, and broader washes, while individual sleeves protect the resilient fibers and a secure tie keeps the compact kit together.",
    attributes: { brushes: "6", material: "Cotton canvas", fibers: "Vegan synthetic" },
    size: ["6-brush set"],
    colors: ["Natural canvas"],
    tags: ["brushes", "painting", "travel"],
    features: ["Six useful brush profiles", "Protective fold-over flap", "Washable wrap"],
    rating: 4.8,
    reviews: 43,
    stock: 21,
    featured: false,
    newArrival: true,
  },
  {
    id: 25,
    name: "Walnut Modular Desk Organizer",
    brand: "ierryhouse Studio",
    category: "More",
    subcategory: "Desk Tools",
    price: 96,
    image: "/img/product-25.png",
    images: ["/img/product-25.png", "/img/product-25-detail.png"],
    description:
      "A compact solid-walnut organizer with three softly rounded compartments for pens, clips, sticky notes, and small desk essentials. The low profile keeps frequently used tools visible without crowding the workspace, while the warm grain and smooth hand-finished edges bring a calm, practical anchor to home and studio desks.",
    attributes: { dimensions: "280 × 180 × 32 mm", material: "Solid walnut", compartments: "3" },
    size: ["Desktop"],
    colors: ["Natural walnut"],
    tags: ["organizer", "desk-tool", "wood"],
    features: ["Three practical compartments", "Smooth rounded edges", "Protective felt feet"],
    rating: 4.8,
    reviews: 31,
    stock: 28,
    featured: true,
    newArrival: true,
  },
];

export default productData;
